import React from 'react';
import PropTypes from 'prop-types';

import { DropdownLanguage } from '@weezevent/nacre';
import i18n from '../../../../i18n/i18n';

export default function Languages({ organization = null, displaySwitchLang = false, minimal = false }) {
    if (!organization || !displaySwitchLang) {
        return null;
    }

    return (
        <DropdownLanguage
            value={i18n.language.replace('-', '_')}
            items={['fr_FR', 'fr_CA', 'fr_CH', 'en_CA', 'en_US', 'en_GB', 'it_IT', 'es_ES', 'de_DE', 'de_CH', 'nl_NL']}
            onChange={value => {}}
        />
    );
}

Languages.propTypes = {
    organization: PropTypes.object,
    displaySwitchLang: PropTypes.bool,
    firstEvent: PropTypes.bool
};
